import { useContext } from "react";

import { CafFormContext } from "../contexts/CafFormContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const useCafForm = () => {
  const context = useContext(CafFormContext);

  if (!context) throw new Error("CafFormContext must be placed within CafFormProvider");

  return context;
};

export default useCafForm;
